import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import { provideValueAccessor } from '@core/shared/util';
import { DropdownComponent } from '@core/ui';
import { TicketPriority } from '@mp/shared/zendesk/domain';

@Component({
  selector: 'mp-support-message-priority-selector',
  templateUrl: './support-message-priority-selector.component.html',
  styleUrl: './support-message-priority-selector.component.scss',
  host: {
    class: 'mp-support-message-priority-selector',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatTooltip, DropdownComponent],
  providers: [provideValueAccessor(SupportMessagePrioritySelectorComponent)],
})
export class SupportMessagePrioritySelectorComponent implements ControlValueAccessor {
  private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  protected ticketPriority!: TicketPriority;

  readonly priorityInfoTooltipText: string = `Normal: Rückmeldung innerhalb eines Werktages
  Dringend: Rückmeldung innerhalb 2 Stunden`;

  readonly prioritiesOptions: { value: TicketPriority; label: string }[] = [
    { value: TicketPriority.Normal, label: 'Normal' },
    { value: TicketPriority.Urgent, label: 'Dringend' },
  ];

  onTicketPriorityChange(ticketPriority: TicketPriority | undefined): void {
    if (!ticketPriority) {
      return;
    }

    this.ticketPriority = ticketPriority;
    this.onChange(this.ticketPriority);
  }

  writeValue(ticketPriority: TicketPriority): void {
    this.ticketPriority = ticketPriority;

    this.cdr.markForCheck();
  }

  onChange = (_value: TicketPriority) => {};

  onTouched = () => {};

  registerOnChange(onChange: (value: TicketPriority) => void) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void) {
    this.onTouched = onTouched;
  }
}
